import { Link, useNavigate } from 'react-router-dom';
const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen md:min-h-[70vh] flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8 bg-gray-50">
            <div className="text-center max-w-xl w-full bg-white p-6 sm:p-8 lg:p-12 rounded-xl shadow-lg">
                <div className="text-7xl sm:text-8xl lg:text-9xl font-bold text-blue-900 leading-none mb-4">
                    404
                </div>

                <h1 className="text-2xl sm:text-3xl lg:text-4xl text-gray-800 mb-4 font-bold">
                    Sayfa Bulunamadı
                </h1>

                <p className="text-base sm:text-lg text-gray-600 mb-2 leading-relaxed px-2">
                    Aradığınız sayfa mevcut değil veya taşınmış olabilir.
                </p>

                <p className="text-sm sm:text-base text-gray-400 mb-8 px-2">
                    Lütfen URL'yi kontrol edin veya ana sayfaya dönün.
                </p>

                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-8 px-2">
                    <Link
                        to="/"
                        className="inline-block px-6 sm:px-8 py-3 sm:py-4 bg-blue-900 !text-white rounded-lg text-sm sm:text-base font-semibold hover:bg-blue-800 transition-all duration-300 shadow-md hover:shadow-lg"
                    >
                        🏠 Ana Sayfaya Dön
                    </Link>

                    <button
                        onClick={() => navigate(-1)}
                        className="px-6 sm:px-8 py-3 sm:py-4 bg-white text-blue-900 border-2 border-blue-900 rounded-lg text-sm sm:text-base font-semibold hover:bg-blue-50 transition-all duration-300 cursor-pointer"
                    >
                        ← Geri Dön
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;